
import ListComponent from "../../../components/boxes/Index.vue";

export default {
  components: {
    ListComponent
  }
}
